module.exports = __webpack_public_path__ + "static/pic29-35502705f80cb43e5f4e2a5163f5813a.png";